import { IPartialTheme, IStyleSet } from "@fluentui/react/lib/Styling"
import { IStyleFunctionOrObject } from "@fluentui/react/lib/Utilities"

import { IParameterStyles } from "./Parameter.types"

export const ParameterStyles: IStyleFunctionOrObject<
    IPartialTheme,
    IStyleSet<IParameterStyles>
> = (theme: IPartialTheme) => ({
    root: {
        minHeight: "1em",
        alignItems: "center",
        selectors: {
            ">*:not(:last-child)": {
                marginRight: "0.5em"
            }
        }
    },
    visible: {
        marginTop: "1.5em",
        marginBottom: "1em"
    },
    label: {
        color: theme.palette?.neutralPrimary,
        padding: "0"
    }
})
